module.exports = __webpack_public_path__ + "success.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success.png
// module id = 1913
// module chunks = 0